import { render, staticRenderFns } from "./PartnerReportCardImages.vue?vue&type=template&id=44ffd77c&scoped=true&"
import script from "./PartnerReportCardImages.vue?vue&type=script&lang=ts&"
export * from "./PartnerReportCardImages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ffd77c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
